import { reactive } from 'vue';
import { NextOrObserver, onAuthStateChanged } from 'firebase/auth';
import { User } from 'firebase/auth';
import { auth } from '@/firebase/init';
import {
  createOrMatchStripeCustomer,
  getStripeCustomer
} from '@/stripe/stripeInit';

type FirebaseAuth = {
  uid: string | null;
  email: string | null;
  stripeId: string | null;
};

const authStore = reactive({
  uid: null as string | null,
  email: null as string | null,
  stripeId: null as string | null
});

/**
 * Authenticates user and stores user data.
 * obtains user stripe customer details and stores those too.
 * If user stripe customer does not exist, creates them here
 */
onAuthStateChanged(auth, async (user) => {
  if (user) {
    authStore.uid = user.uid;
    authStore.email = user.email;
    // obtain stripe details
    try {
      let stripeCustomer = await getStripeCustomer({
        email: user.email || undefined,
        uid: user.uid || undefined
      });
      if (!stripeCustomer && user.email) {
        stripeCustomer = await createOrMatchStripeCustomer({
          email: user.email,
          uid: user.uid
        });
      }
      if (stripeCustomer) {
        authStore.stripeId = stripeCustomer.id;
      }
    } catch (e) {
      if (!user.email) return;
      let stripeCustomer = await createOrMatchStripeCustomer({
        email: user.email,
        uid: user.uid
      });
      if (stripeCustomer) {
        authStore.stripeId = stripeCustomer.id;
      }
    }
  } else {
    authStore.uid = null;
    authStore.email = null;
    authStore.stripeId = null;
  }
});

const authObserver = (fn: NextOrObserver<User>) => onAuthStateChanged(auth, fn);

export { authObserver, FirebaseAuth };
export default authStore;
